import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Label, Paragraph } from 'components/primitives'
import Margin, { MarginProps } from 'components/Margin'
import { UpdatedTimestamp } from './Dispatch'
import { Modified } from 'types/callstore'
import { LocationPayload } from 'types/location'

export type Props = {
  label?: string
  location?: (LocationPayload & Modified) | null
  children?: React.ReactNode
} & Pick<MarginProps, 'spacing'>

export const IncidentLocation = ({ label, location, spacing = 'none', children }: Props) => {
  return (
    <Margin spacing={spacing}>
      {label && <Label>{label}</Label>}
      {location?.modified && <UpdatedTimestamp timestamp={location.modified} />}
      <LocationAddress location={location} />
      {children}
    </Margin>
  )
}

export const LocationAddress = ({ location }: Pick<Props, 'location'>) => {
  return location && location.addressDescription ? (
    <Paragraph
      dangerouslySetInnerHTML={{
        __html: `${location.addressDescription}<br/>(${location.latitude}, ${location.longitude}) `,
      }}
    />
  ) : null
}

export const Caller = (props: Props) => {
  const { t } = useTranslation()
  return <IncidentLocation label={t('labels.callerLocation')} {...props} />
}

export const Vehicle = (props: Props) => {
  const { t } = useTranslation()
  return <IncidentLocation label={t('labels.vehicleLocation')} {...props} />
}

export const VehicleDestination = (props: Props) => {
  const { t } = useTranslation()
  return <IncidentLocation label={t('labels.vehicleDestinationLocation')} {...props} />
}

export const CallerDestination = (props: Props) => {
  const { t } = useTranslation()
  return <IncidentLocation label={t('labels.callerDestinationLocation')} {...props} />
}

export default Object.assign(IncidentLocation, {
  Caller,
  Vehicle,
  VehicleDestination,
  CallerDestination,
})
